<template>
  <div>
    <div class="home" v-if="!isJgxtBase">
      <!-- 头部 -->
      <div class="home_head">
        <div class="left-info">
          <img src="@/assets/images/login/tuBiao.png" alt="" style="width: 20px;margin: 0px 10px 0px 25px;">
          <p class="title">11陪诊后台系统</p>
          <div style="margin-left: 25px;line-height: 12px;font-size: 16px;"><a-icon :type="collapsed ? 'menu-unfold' : 'menu-fold'" @click="toggleCollapsed"/></div>
          <!-- <div class="vertical-line"></div>  -->
          <p class="userName">{{ userName }}</p>
          <a-dropdown>
            <a-avatar style="cursor: pointer;float: right;position: absolute;right: 20px;" size="large" icon="user" @click="e => e.preventDefault()" />
            <a-menu slot="overlay">
              <a-menu-item>
                <a href="javascript:;" @click="visible = true">修改密码</a>
              </a-menu-item>
              <a-menu-item>
                <a href="javascript:;" @click="loginOut()">退出登录</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </div>
      </div>
      <!-- 内容 -->
      <div class="home_content">
        <!-- 左側列表 -->
        <div class="home_content_left" :style="{ width: collapsed ? '70px' : '212px' }">
          <div style="overflow-y: auto;height: calc(100vh - 52px);">
            <NavMenus @tabsInfo="tabsInfo" ref="navMenu" :key="navKey" :collapsed="collapsed"></NavMenus>
          </div>
        </div>
        <!-- 右侧内容 -->
        <div class="home_content_right" :style="{ width: collapsed ? 'calc(100% - 70px)' : 'calc(100% - 212px)' }">
            <a-tabs v-model="activeKey" hide-add type="editable-card" @edit="onEdit" @tabClick="tabClick">
              <a-tab-pane v-for="pane in panes" :key="pane.mlink" :tab="pane.title">
              </a-tab-pane>
            </a-tabs>
              <router-view @management="management"/>
        </div>
      </div>

      <!-- 表单 -->
      <a-modal  on-ok="handleOk" :destroyOnClose="true" :maskClosable="false" v-model="visible"
        v-if="visible">
        <div slot="title" class="tip-icon"> 修改密码 </div>
        <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
          <a-form-model-item label="旧密码" prop="oldLandPswd" ref="oldLandPswd">
            <a-input-password size="large" placeholder="请输入旧密码" v-model="form.oldLandPswd" allow-clear>
              <a-icon slot="prefix" type="lock" :style="{ color: 'rgba(0,0,0,.25)' }" />
            </a-input-password>
          </a-form-model-item>
          <a-form-model-item label="新密码" prop="newLandPswd" ref="newLandPswd">
            <a-input-password size="large" placeholder="请输入新密码" v-model="form.newLandPswd" allow-clear>
              <a-icon slot="prefix" type="lock" :style="{ color: 'rgba(0,0,0,.25)' }" />
            </a-input-password>
          </a-form-model-item>
          <a-form-model-item label="确认新密码" prop="newLandPswd2">
            <a-input-password size="large" placeholder="请输入新密码" v-model="form.newLandPswd2" allow-clear>
              <a-icon slot="prefix" type="lock" :style="{ color: 'rgba(0,0,0,.25)' }" />
            </a-input-password>
          </a-form-model-item>
        </a-form-model>
        <template slot="footer">
          <a-button type="primary" key="submit" class="btaction" @click="handleOk">
            确认
          </a-button>
        </template>
      </a-modal>
    </div>

  </div>
</template>

<script>
import NavMenusComponent from '@components/nav-menus';
import { logOut } from "@/api/login.js"
import { userupdatepassword } from "@/api/api.js"
import { watch } from 'vue';
export default {
  name: 'Home',
  components: {
    NavMenus: NavMenusComponent
  },
  data() {
    const handleConfirmPass = (rule, value, callback) => {
      if (this.form.newLandPswd && this.form.newLandPswd !== value) {
        callback(new Error('两次密码输入不一致！'))
      }
      callback()
    }
    return {
      search: '',
      userName: sessionStorage.getItem('userName'),
      visible: false,
      form: {
        oldLandPswd: "",
        newLandPswd: ""
      },
      rules: {
        oldLandPswd: [
          {
            required: true,
            message: "旧不能为空！",
            trigger: "blur",
          },

        ],
        newLandPswd: [
          {
            required: true,
            message: "新密码不能为空！",
            trigger: "blur",
          },
          {
            min: 6,
            max: 10,
            message: '密码长度6-10'
          }
        ],
        newLandPswd2: [
          {
            required: true,
            message: "请再次确认密码！",
            trigger: "blur",
          },
          {
            min: 6,
            max: 10,
            message: '密码长度6-10'
          }
        ]
      },
      // 页签控制
      panes: null,
      activeKey: null,
      newTabIndex: null,
      isJgxtBase: false,
      n: this.$route.path,

      navKey: "",
      openKeys: [],
      collapsed:false,
      
    }
  },
  beforeCreate() {
    if (!sessionStorage.getItem('localstate')) {
      this.$store.dispatch('LogOut').then(() => {
        router.push({ name: 'Login', query: { loginOut: true } })
        setTimeout(() => { window.location.reload(); }, 300);
      })
      return
    }
  },
  mounted() {
    this.showTab();
  },
  watch: {
    // 页签设置更改时缓存
    activeKey: {
      handler(e) {
        sessionStorage.setItem('activeKey', e)
      },
    },
    '$route': {
      handler(newoute, oldroute) {
        this.activeKey = newoute.path;
      }
    },
    newTabIndex: {
      handler(e) {
        sessionStorage.setItem('newTabIndex', e)
      },
    }
  },

  methods: {
    showTab() {
      if (!JSON.parse(sessionStorage.getItem('panes'))) { //没有默认页签（刚登陆如果第一个路由为空）
        this.panes = []
      } else if (!JSON.parse(sessionStorage.getItem('panes')).length) { //有一个默认页签
        const newpane = []

        let tabArr = JSON.parse(sessionStorage.getItem('panes'));
        if (tabArr.length && tabArr.length > 0) {
          tabArr.forEach(element => {
            const { key, title, mlink } = element
            newpane.push({ key, title, mlink })
          });
          this.panes = newpane
        } else {
          const { key, title, mlink } = JSON.parse(sessionStorage.getItem('panes'))
          const newitem = [{ key, title, mlink }]
          this.panes = newitem
        }

      } else if (JSON.parse(sessionStorage.getItem('panes')).length) {
        const newpane = []

        let tabArr = JSON.parse(sessionStorage.getItem('panes'));
        if (tabArr.length && tabArr.length > 0) {
          tabArr.forEach(element => {
            const { key, title, mlink } = element
            newpane.push({ key, title, mlink })
          });
          this.panes = newpane
        } else {
          const { key, title, mlink } = JSON.parse(sessionStorage.getItem('panes'))
          const newitem = [{ key, title, mlink }]
          this.panes = newitem
        }
      }
      this.activeKey = this.$route.path
    },

    // removeOut() {
    
    //   console.log(this.activeKey, '++')
    //   console.log(this.panes, 'this.panes')
    //   let List = this.panes
    //   this.panes = []
    //   List.map(item => {
    //     if (item.mlink == this.activeKey) {
    //       this.panes.push(item)
    //     }
    //   })
    //    //   let len = this.panes.length
    // //    let list = this.panes[len-1]
      
     
     
    // sessionStorage.setItem('panes', JSON.stringify(this.panes))
      
    //   this.activeKey = this.panes[0].mlink
    //   this.$router.push({ path: this.panes[0].mlink  })
    // },
    // leftOut() {
    //   console.log(this.activeKey, '++')
    //   console.log(this.panes, 'this.panes')
     
    //   let List = this.panes
    //   console.log(List, '----  ')
    //   let len = (List||[]).findIndex(item=>item.mlink === this.activeKey);
    //   console.log(len)
    //   List.splice(0,len)
    //   this.panes.concat(List)
    //   sessionStorage.setItem('panes', JSON.stringify(this.panes))
    //   this.activeKey = this.panes[0].mlink
    //   this.$router.push({ path: this.panes[0].mlink  })
    // },
    // rightOut() {
    //   console.log(this.activeKey, '++')
    //   console.log(this.panes, 'this.panes')
     
    //   let List = this.panes
    //   let lenmax = List.length
    //   console.log(List, '----  ')
    //   let len = (List||[]).findIndex(item=>item.mlink === this.activeKey);
    //   console.log(len)
    //   List.splice(len+1,lenmax-1)
    //   this.panes.concat(List)
    //   let dlen = this.panes.length
    //   console.log(dlen, '最大长度')
    //   sessionStorage.setItem('panes', JSON.stringify(this.panes))
    //   this.activeKey = this.panes[dlen-1].mlink
    //   this.$router.push({ path: this.panes[dlen-1].mlink  })
    // },
    // 登出
    loginOut() {
      logOut({
        sid: sessionStorage.getItem('sid')
      }).then((res) => {
        this.$store.dispatch('LogOut').then(() => {
          this.$router.push({ name: 'Login', query: { loginOut: true } })
          setTimeout(() => { window.location.reload(); }, 300);
        })
      })
      window.localStorage.clear()
      window.sessionStorage.clear()
    },
    handleOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.form.newLandPswd !== this.form.newLandPswd2) {
            this.$message.error('两次输次密码不一致!')
          } else {
            userupdatepassword({
              "newPassword": this.form.newLandPswd,
              "oldPassword": this.form.oldLandPswd,
              "userId": sessionStorage.getItem('userId'),
            }).then(res => {
              this.visible = false
              this.form
              this.$message.success('修改密码成功!')
              this.$refs["ruleForm"].resetFields();
            })
          }

        }

      })


    },
    // 页签控制
    tabsInfo(e) {
      this.panes.push(e);


      let newArr = [];
      let obj = {};
      for (var i = 0; i < this.panes.length; i++) {
        if (!obj[this.panes[i].mlink]) {
          newArr.push(this.panes[i])
          obj[this.panes[i].mlink] = true
        }
      }
      this.panes = newArr

      sessionStorage.setItem('panes', JSON.stringify(newArr))
      this.activeKey = e.mlink
    },
    onEdit(targetKey, action) {
      if (action == 'remove') {
        if (this.panes.length && this.panes.length == 1) {
          return
        }
        let id = this.panes.findIndex((item) => {
          if (item.mlink == targetKey) {
            return true;
          }
        });
        this.panes.splice(id, 1)
        sessionStorage.setItem('panes', JSON.stringify(this.panes))
        if (targetKey == this.$route.path) {
          let length = this.panes.length - 1
          this.activeKey = this.panes[length].mlink
          this.$router.push({ path: this.panes[length].mlink })
        }else if(targetKey+"-details" == this.$route.path){
          //关闭客户服务套餐、客户管理患者信息详情页面
          let length = this.panes.length - 1
          this.activeKey = this.panes[length].mlink
          this.$router.push({ path: this.panes[length].mlink })
        }else if(targetKey+"-det" == this.$route.path){
          //关闭会员权益详情页面
          let length = this.panes.length - 1
          this.activeKey = this.panes[length].mlink
          this.$router.push({ path: this.panes[length].mlink })
        }else if("/home/user/assignRoles" == this.$route.path){
          //关闭分配角色页面
          let length = this.panes.length - 1
          this.activeKey = this.panes[length].mlink
          this.$router.push({ path: this.panes[length].mlink })
        }else if(targetKey+"/assignUsers" == this.$route.path){
          //关闭分配用户页面
          let length = this.panes.length - 1
          this.activeKey = this.panes[length].mlink
          this.$router.push({ path: this.panes[length].mlink })
        }else if(targetKey+"/role-allocation" == this.$route.path){
          //关闭分配菜单页面
          let length = this.panes.length - 1
          this.activeKey = this.panes[length].mlink
          this.$router.push({ path: this.panes[length].mlink })
        }else if("/home/system/allocation" == this.$route.path){
          //关闭字典管理配置页面
          let length = this.panes.length - 1
          this.activeKey = this.panes[length].mlink
          this.$router.push({ path: this.panes[length].mlink })
        }

      }
    },
    tabClick(key) {
      this.$router.push({ path: key })
    },

    management(data) {
      let menuDataNew;
      let obj = {};
      let flag = 0;
      let key = "";
      for (let i = 0; i < this.panes.length; i++){
        if (this.panes[i].title == data.title) {
          flag = 1;
          break;
        }
      }
      if (flag == 0) {
        menuDataNew = JSON.parse(sessionStorage.getItem('menuData'));
        menuDataNew.forEach(item => {
          if (item.title == data.fatherTitle) {
            key = item.key;
            item.children.forEach(i => {
              if (i.title == data.title) {
                const { key, title, mlink } = i;
                obj = ({ key, title, mlink });
              }
            })
          }
        });
        this.panes.push(obj);
        sessionStorage.setItem('panes', JSON.stringify(this.panes));
        this.openKeys = JSON.parse(sessionStorage.getItem('openKeys'));
        this.openKeys.push(key)
        sessionStorage.setItem('openKeys', JSON.stringify(this.openKeys));
        this.navKey = Date.now();
      }
      this.activeKey = data.mlink;
      this.$router.push({ path: data.mlink })
    },

    toggleCollapsed() {
      this.collapsed = !this.collapsed;
      this.navKey = Date.now();
    }
  },
}
</script>
<style scoped="scoped" lang="less">
.home {
  width: 100%;
  height: 100%;
  overflow-y: hidden;
  display: flex;
  flex-direction: column;
/deep/ .ant-avatar-lg{
    width: 35px;
    height: 35px;
    line-height: 35px;
    border-radius: 50%;
}
/deep/ .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active{
  color: rgba(22, 130, 139, 1);
  // border-bottom: 1px solid rgba(22, 130, 139, 1);
}
  .title{
    font-size: 18px;
    font-weight: 700;
    letter-spacing: 0px;
    line-height: 26.06px;
    color: rgba(255, 255, 255, 1);
    text-align: left;
    vertical-align: top;
  }

  .content-box {
    width: calc(100% - 212px);
    height: 100%;

    .header-bar {
      width: 100%;
      display: flex;
      padding: 0 10px;
      box-sizing: border-box;
      // justify-content: flex-end;
      align-items: center;
      // height: 65px;
      height: 52px;
      background: rgba(22, 130, 139, 1);

      .searchInput {
        width: 20%;
        margin-right: 2%;

        ::v-deep .ant-input-prefix {
          color: rgb(102, 106, 134) !important;
        }

        ::v-deep .ant-input {
          background: none !important;
          color: #fff;
          border-color: rgb(102, 106, 134) !important;
        }

        ::v-deep .ant-input:-moz-placeholder,
        textarea:-moz-placeholder {
          color: rgb(102, 106, 134) !important;
        }

        ::v-deep .ant-input:-ms-input-placeholder,
        textarea:-ms-input-placeholder {
          color: rgb(102, 106, 134) !important;
        }

        ::v-deep .ant-input::-webkit-input-placeholder,
        textarea::-webkit-input-placeholder {
          color: rgb(102, 106, 134) !important;
        }


      }

    }

    .right-view {
      width: 100%;
      // height: 100%;
      // height: calc(100vh - 52px);
      padding: 10px;
    }
  }

  // 微前端调整
  &.micro-frontends-type {
    .left-nav {
      // display: none;
    }
  }
}

.userName {
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  position: absolute;
  right: 60px;
  float: right;
}

.home_head{
  height: 52px;
  width: 100%;
  align-items: center;
  background: #16828b;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
}

.home_content{
  height: calc(100vh - 52px);
  width: 100%;
  display: flex;

  .home_content_left{
    width: 212px;
    height: 100%;
    background: #16828b;
  }

  .home_content_right{
    width: calc(100% - 212px);
    height: 100%;
    padding: 10px;
  }
}

.vertical-line {
    width: 2px;
    height: 16px;
    opacity: 1;
    border-radius: 1px;
    background: rgba(255, 255, 255, 1);
    margin-right: 20px;
    margin-left: 40px;
}

.left-info {
  display: flex;
  align-items: center;
  height: 52px;
  box-shadow: 0px 2px 4px  rgba(0, 0, 0, 0.1);
  font-size: 30px;
  color: #fff;

  .logo {
    width: 35px;
    height: 35px;
    margin-top: 7px;
    margin-right: 20px;

    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }

  .system-name {
    font-size: 15px;
    color: #fff;
  }
}

// 用户、登出
.right-info {
  color: #999;
  padding-right: 50px;

  .login-out {
    height: 50px;
    cursor: pointer;

    i {
      font-size: 20px;

      &:hover {
        color: #fff;
      }
    }
  }

  .user-info {
    margin-right: 30px;
    height: 50px;

    &:hover {
      color: #fff;
    }

    .user-head {
      vertical-align: middle;
      margin-right: 5px;

      i {
        font-size: 22px;
      }
    }
  }
}




</style>
